import React from "react";
import { motion } from "framer-motion";
import styles from "../../pages/css/Dashboard.module.css";

const DashboardHeader = ({
  isLoading,
  headerContainerVariants,
  textFadeUpVariants,
}) => {
  return (
    <motion.div
      className={styles.dashboardHeader}
      variants={headerContainerVariants}
      initial="hidden"
      animate={isLoading ? "hidden" : "visible"}
    >
      <motion.h2 className={styles.dashboardTitle} variants={textFadeUpVariants}>
        Dashboard Overview
      </motion.h2>
      <motion.p className={styles.dashboardSubtitle} variants={textFadeUpVariants}>
        Welcome back! Manage your crypto gateway transactions and balance.
      </motion.p>
    </motion.div>
  );
};

export default DashboardHeader;
